// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { stopSquare16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-stop-square': IconStopSquare;
    }
}

/**
 * The icon component for the 'stopSquare' icon
 */
export class IconStopSquare extends IconSvg {
    public constructor() {
        super(stopSquare16X16);
    }
}

registerIconSvg('icon-stop-square', IconStopSquare);
export const iconStopSquareTag = 'nimble-icon-stop-square';
